import Image from "next/image";
import { SECTION_IDS } from "./content";

export const Contact = () => (
  <section
    id={SECTION_IDS.contact}
    className="relative overflow-hidden px-[clamp(16px,4vw,64px)] py-[clamp(130px,18vw,280px)]"
  >
    <div className="absolute inset-0">
      <Image
        src="/images/africa2.webp"
        alt=""
        fill
        sizes="100vw"
        className="object-cover opacity-[.34] saturate-[.7] [animation:dc-drift_70s_ease-in-out_infinite]"
      />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,#030C16_0%,rgba(3,12,22,.78)_40%,rgba(3,12,22,.86)_100%)]" />
    </div>

    <div className="dc-shell relative z-2">
      <h2 className="m-0 text-[clamp(48px,11vw,200px)] font-bold leading-[.84] tracking-[-.05em]">
        BRING US
        <br />
        ONE
        <br />
        QUESTION.
      </h2>

      <div className="mt-[clamp(46px,6vw,84px)] grid grid-cols-[repeat(auto-fit,minmax(min(100%,300px),1fr))] items-end gap-[clamp(28px,4vw,72px)] border-t border-white/20 pt-[34px]">
        <p className="m-0 max-w-[32ch] text-[clamp(17px,1.6vw,23px)] leading-[1.5] text-paper-2">
          Something worth knowing, understanding or changing. We&apos;ll show you
          what the data can reveal.
        </p>
        <div>
          <a
            href="mailto:contact@haizea.com.au"
            className="inline-flex items-center gap-3 bg-mint px-9 py-[19px] text-base font-semibold text-ink transition-colors duration-300 hover:bg-paper"
          >
            Start a conversation <span className="dc-mono">→</span>
          </a>
          <div className="dc-mono mt-[26px] text-[12px] leading-[2.1] tracking-[.14em] text-mist-5">
            Gould Building (B116), Daley Road
            <br />
            Canberra ACT 2600 · contact@haizea.com.au
            <br />
            <span className="text-mist-5">
              ABN 27 648 451 969 · Founded 2021
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
